import React from "react";
import CustomerDetailItemOne from "./CustomerDetailItemOne";

const CustomerDetail = ({customer}) => {
    function extractName(customerBasicDetail) {
        let salutation = customerBasicDetail.primary_contact_salutation
            ? customerBasicDetail.primary_contact_salutation.name
            : "";
        let lastName = customerBasicDetail.primary_contact_last_name
            ? customerBasicDetail.primary_contact_last_name
            : "";

        return (
            salutation +
            customerBasicDetail.primary_contact_first_name +
            " " +
            lastName
        );
    }

    return (
        <div>
            {customer && customer.success ? (
                <div className="p-4">

                    <h3 className="text-base font-semibold leading-7 text-gray-900 underline">
                       Member Details
                    </h3>

                    <dl className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4">

                        <CustomerDetailItemOne
                            label="Member Type"
                            value={customer?.customer_basic_detail?.customer_type?.name}
                        />
                        <CustomerDetailItemOne
                            label="Name"
                            value={extractName(customer.customer_basic_detail)}
                        />
                        <CustomerDetailItemOne
                            label="Gender"
                            value={customer.customer_basic_detail.gender?.name}
                        />
                        <CustomerDetailItemOne
                            label="Blood Group"
                            value={customer.customer_basic_detail.blood_group?.name}
                        />
                        <CustomerDetailItemOne
                            label="Date of Birth"
                            value={customer.customer_basic_detail.customer_date_of_birth}
                        />
                        <CustomerDetailItemOne
                            label="House Number"
                            value={customer.customer_basic_detail.house_number.house_number}
                        />
                        <CustomerDetailItemOne
                            label="Email"
                            value={customer.customer_basic_detail.customer_email}
                        />
                        <CustomerDetailItemOne
                            label="Mobile"
                            value={customer.customer_basic_detail.customer_mobile}
                        />
                        <CustomerDetailItemOne
                            label="Primary Contact Status"
                            value={
                                customer.customer_basic_detail.customer_primary_contact_status
                                    ? "Yes"
                                    : "No"
                            }
                        />
                        <CustomerDetailItemOne
                            label="Profession"
                            value={customer.customer_basic_detail.profession?.name}
                        />
                        <CustomerDetailItemOne
                            label="House Rent"
                            value={customer.customer_basic_detail.item?.name}
                        />


                    </dl>
                    <h3 className="mt-5 text-base font-semibold leading-7 text-gray-900 underline">
                    Member Address
                    </h3>
                    <dl className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4">
                        <CustomerDetailItemOne
                            label="Country Region"
                            value={
                                customer.customer_basic_detail.customer_address.country?.name
                            }
                        />
                        <CustomerDetailItemOne
                            label="Street One"
                            value={
                                customer.customer_basic_detail.customer_address
                                    .billing_address_street_one
                            }
                        />
                        <CustomerDetailItemOne
                            label="Street Two"
                            value={
                                customer.customer_basic_detail.customer_address
                                    .billing_address_street_two
                            }
                        />
                        <CustomerDetailItemOne
                            label="City"
                            value={
                                customer.customer_basic_detail.customer_address.billing_city
                            }
                        />
                        <CustomerDetailItemOne
                            label="State"
                            value={
                                customer.customer_basic_detail.customer_address.state?.name
                            }
                        />
                        <CustomerDetailItemOne
                            label="Zip Code"
                            value={
                                customer.customer_basic_detail.customer_address.billing_zip_code
                            }
                        />
                        <CustomerDetailItemOne
                            label="Phone"
                            value={
                                customer.customer_basic_detail.customer_address.billing_phone
                            }
                        />
                    </dl>

                    <h3 className="mt-5 text-base font-semibold leading-7 text-gray-900 underline">
                        Contact People
                    </h3>

                    {customer.customer_basic_detail.contact_people.length === 0 ? (
                        <div>No contact people</div>
                    ) : (
                        customer.customer_basic_detail.contact_people.map((contact, index) => (
                            <dl key={index} className="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4">

                                    <CustomerDetailItemOne
                                        label="Name"
                                        value={contact.contact_person_first}
                                    />
                                    <CustomerDetailItemOne
                                        label="Gender"
                                        value={contact.contact_people_gender?.name}
                                    />
                                    <CustomerDetailItemOne
                                        label="Mobile"
                                        value={contact.contact_person_mobile}
                                    />
                                    <CustomerDetailItemOne
                                        label="Date of Birth"
                                        value={contact.contact_person_date_of_birth}
                                    />
                                    <CustomerDetailItemOne
                                        label="BloodGroup"
                                        value={contact.contact_people_blood_group?.name}
                                    />
                                    <CustomerDetailItemOne
                                        label="Relationship"
                                        value={contact.contact_people_relationship?.name}
                                    />

                            </dl>
                        ))
                    )}

                </div>
            ) : (
                <div>Member data not available</div>
            )}
        </div>
    );
};

export default CustomerDetail;
